
import { getStore } from "../store/configureStore";
import * as exceptions from "../actions/exceptionActions";
import { LogLevel, PublicClientApplication } from "@azure/msal-browser";

import "regenerator-runtime";

const store = getStore();

let level;
if (process.env.NODE_ENV === 'production') {
    level = LogLevel.Warning;
} else {
    level = LogLevel.Verbose;
}

const config = {
    auth: {
        authority: "https://login.microsoftonline.com/ca9d2f79-c2d1-406f-93ca-8b96453f4f8d",
        clientId: window.settings.ClientId,
        redirectUri: window.location.origin + window.settings.SiteRoot + "backoffice",
        navigateToLoginRequestUrl: false
    },
    system: {
        loggerOptions: {
            loggerCallback: (logLevel, message, containsPii) => {
                logToServer(logLevel, message);
                logToConsole(logLevel, message);
            },
            level: level,
            piiLoggingEnabled: false
        }
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false
    }
};

function logToServer(logLevel, message) {
    if (logLevel === LogLevel.Warning || logLevel === LogLevel.Error) {
        const prefix = logLevel === LogLevel.Warning ? "[MSAL Warning] " : "[MSAL Error] ";
        store.dispatch(exceptions.throwException(prefix + message, false));
    }
}

function logToConsole(logLevel, message) {
    if (process.env.NODE_ENV === 'production') return;
    /* eslint no-console: ["error", { allow: ["log", "warn", "error"]}] */

    if (logLevel === LogLevel.Verbose || logLevel === LogLevel.Info) {
        console.log("[MSAL]", message);
    }
    if (logLevel === LogLevel.Warning) {
        console.warn("[MSAL]", message);
    }
    if (logLevel === LogLevel.Error) {
        console.error("[MSAL]", message);
    }
}

export const authClientApplication = new PublicClientApplication(config);
